import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import * as Sentry from "@sentry/react";

import {
  Home,
  Nav,
  About,
  TechStack,
  Project,
  Contact,
} from "./component/export";

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<h2>Something went wrong 😢</h2>}>
      <div className="app">
        <Router>
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/tech-stack" element={<TechStack />} />
            <Route path="/project" element={<Project />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Router>
      </div>
    </Sentry.ErrorBoundary>
  );
}

export default App;
